import { IonText } from '@ionic/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

const NotificationsGettingStarted = (): ReactElement => {
  const { i18n } = useTranslation();
  return (
    <div className="full-height-width content-center">
      <IonText className="ion-padding ion-text-center" color="medium">
        <h2>{i18n.t('common:notifications_getting_started')}</h2>
        <p />
        {i18n.t('common:notifications_getting_started_description')}
      </IonText>
    </div>
  );
};

export { NotificationsGettingStarted };
